// import React, { useState } from 'react'
// import PatientBasicDetails from "./patientBasicDetails"
// import RpmDetails from './ProviderDetails';
// import ProgramInsurance from './programAndInsurance';
// import VitalConfiguration from './vitalConfiguration';
// import Devices from './RpmDevices';
// import img1 from "../../../../Assets/Images/Vector1.png";
// import img2 from "../../../../Assets/Images/Vector2.png";
// import img3 from "../../../../Assets/Images/Vector3.png";
// import img4 from "../../../../Assets/Images/Vector4.png";
// import img5 from "../../../../Assets/Images/Vector5.png";
// import { CheckOutlined } from "@ant-design/icons";

// function Index({ handleCancel, handleSave }) {
//     const [currPageView, setCurrPageView] = useState(1);

//     const handleNext = () => {
//         setCurrPageView((prevState) => prevState + 1);
//     }

//     const handlePrevious = () => {
//         setCurrPageView((prevState) => prevState - 1);
//     }

//     const steps = [
//         { id: 1, title: "Basic Details", icon: <img src={img1} alt="img" /> },
//         { id: 2, title: "Provider", icon: <img src={img2} alt="img" /> },
//         { id: 3, title: "Program / Insurance", icon: <img src={img3} alt="img" /> },
//         { id: 4, title: "Configuration", icon: <img src={img4} alt="img" /> },
//         { id: 5, title: "Devices", icon: <img src={img5} alt="img" /> },
//     ];

//     return (
//         <div className="pl-5">
//             <div className="w-[80%] mx-auto my-4 px-4 pt-2">
//                 <div className="flex justify-between items-center w-full mb-3">
//                     {steps.map((step) => {
//                         const isCompleted = currPageView > step.id;
//                         const isActive = currPageView === step.id;

//                         return (
//                             <div
//                                 key={step.id}
//                                 className="flex flex-col items-center cursor-pointer select-none"
//                             // onClick={() => setCurrPageView(step.id)}
//                             >
//                                 <div
//                                     className={`
//               w-9 h-9 flex items-center justify-center rounded-full border-2 transition-all
//               ${isCompleted
//                                             ? "bg-teal-500 border-teal-500 text-white"
//                                             : isActive
//                                                 ? "border-teal-500 text-teal-500 bg-white"
//                                                 : "border-gray-300 text-gray-400 bg-white"
//                                         }
//             `}
//                                 >
//                                     {isCompleted ? <CheckOutlined /> : step.icon}
//                                 </div>
//                             </div>
//                         );
//                     })}
//                 </div>

//                 <div className="relative w-full h-1 bg-gray-200 rounded-full my-2">
//                     <div
//                         className="absolute h-2 bg-teal-500 rounded-full transition-all duration-500"
//                         style={{
//                             width: `${((currPageView - 1) / (steps.length - 1)) * 100}%`,
//                         }}
//                     />
//                 </div>

//                 <div className="flex justify-between items-center w-full mt-3">
//                     {steps.map((step) => {
//                         const isCompleted = currPageView > step.id;
//                         const isActive = currPageView === step.id;

//                         return (
//                             <div
//                                 key={step.id}
//                                 className="flex flex-col items-center cursor-pointer select-none"
//                             // onClick={() => setCurrPageView(step.id)}
//                             >
//                                 <span
//                                     className={`
//               text-xs font-medium
//               ${isCompleted || isActive ? "text-black" : "text-gray-400"}
//             `}
//                                 >
//                                     {step.title}
//                                 </span>
//                             </div>
//                         );
//                     })}
//                 </div>
//             </div>

//             <div className="disabled:cursor-not-allowed disabled:opacity-0">
//                 <div className={currPageView === 1 ? "block" : "hidden"}>
//                     <PatientBasicDetails
//                         handleCancel={handleCancel}
//                         handleSave={handleSave}
//                         handleNext={handleNext}
//                     />
//                 </div>

//                 <div className={currPageView === 2 ? "block" : "hidden"}>
//                     <RpmDetails
//                         currPageView={currPageView}
//                         handleCancel={handleCancel}
//                         handleNext={handleNext}
//                         handlePrevious={handlePrevious}
//                     />
//                 </div>

//                 <div className={currPageView === 3 ? "block" : "hidden"}>
//                     <ProgramInsurance
//                         currPageView={currPageView}
//                         handleCancel={handleCancel}
//                         handleNext={handleNext}
//                         handlePrevious={handlePrevious}
//                     />
//                 </div>

//                 <div className={currPageView === 4 ? "block" : "hidden"}>
//                     <VitalConfiguration
//                         currPageView={currPageView}
//                         handleCancel={handleCancel}
//                         handleNext={handleNext}
//                         handlePrevious={handlePrevious}
//                     />
//                 </div>

//                 <div className={currPageView === 5 ? "block" : "hidden"}>
//                     <Devices
//                         currPageView={currPageView}
//                         handleCancel={handleCancel}
//                         handleNext={handleNext}
//                         handlePrevious={handlePrevious}
//                     />
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default Index;

import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CheckOutlined,
  ExclamationCircleOutlined,
  LockOutlined,
} from "@ant-design/icons";
import PatientBasicDetails from "./patientBasicDetails";
import RpmDetails from "./ProviderDetails";
import ProgramInsurance from "./programAndInsurance";
import VitalConfiguration from "./vitalConfiguration";
import Devices from "./RpmDevices";
import img1 from "../../../../Assets/Images/Vector1.png";
import img2 from "../../../../Assets/Images/Vector2.png";
import img3 from "../../../../Assets/Images/Vector3.png";
import img4 from "../../../../Assets/Images/Vector4.png";
import img5 from "../../../../Assets/Images/Vector5.png";
import {
  handleClearPatientRegistrationPayload,
  handleSetPatientRegistrationPayload,
} from "../../../../Redux/actions/patientActions";

const STEPS = [
  { id: 1, title: "Basic Details", icon: img1 },
  { id: 2, title: "Provider", icon: img2 },
  { id: 3, title: "Program / Insurance", icon: img3 },
  { id: 4, title: "Configuration", icon: img4 },
  { id: 5, title: "Devices", icon: img5 },
];

const getValidationRules = (payload) => [
  { tab: 1, message: "First name is required", invalid: !payload?.firstName },
  { tab: 1, message: "Last name is required", invalid: !payload?.lastName },
  { tab: 1, message: "Mobile number is required", invalid: !payload?.mobile },
  {
    tab: 1,
    message: "Please enter a valid mobile number.",
    invalid: payload?.mobile && !/^\d{10,15}$/.test(payload.mobile),
  },
  // { tab: 1, message: "Please select a referral user", invalid: !payload?.userId && !payload?.patientId },
  {
    tab: 1,
    message: "Email is invalid",
    invalid:
      payload?.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(payload.email),
  },
  {
    tab: 1,
    message: "SOS: Contact 1 is required",
    invalid: payload?.sos === "Y" && !payload?.erContactNo1,
  },
  {
    tab: 1,
    message: "SOS: Contact 2 is required",
    invalid: payload?.sos === "Y" && !payload?.erContactNo2,
  },
  {
    tab: 1,
    message: "SOS: Contact 3 is required",
    invalid: payload?.sos === "Y" && !payload?.erContactNo3,
  },
  {
    tab: 1,
    message: "SOS: Contact 4 is required",
    invalid: payload?.sos === "Y" && !payload?.erContactNo4,
  },
  {
    tab: 1,
    message: "Watch ID is required",
    invalid: payload?.rpmSmartWatch === "Y" && !payload?.smartWatchUserId,
  },
  {
    tab: 1,
    message: "Omron ID is required",
    invalid: payload?.omranConnectYN === "Y" && !payload?.omranConnectId,
  },
  {
    tab: 2,
    message: "Hospital is required",
    invalid: payload?.rpmApplicable === "Y" && !payload?.hospitalId,
  },
  {
    tab: 2,
    message: "Location is required",
    invalid: payload?.rpmApplicable === "Y" && !payload?.locationId,
  },
  {
    tab: 2,
    message: "Provider is required",
    invalid: payload?.rpmApplicable === "Y" && !payload?.providerCode,
  },
];

function Index({ handleCancel, handleSave }) {
  const dispatch = useDispatch();

  // Read rpmApplicable LIVE from Redux — updates the moment Tab 1 checkbox dispatches
  const { registrationPayload, selectedEditPatient } = useSelector(
    (s) => s.patients,
  );
  const isRpmEnabled = registrationPayload?.rpmApplicable === "Y" || selectedEditPatient?.rpmApplicable === "Y";
  const [currPageView, setCurrPageView] = useState(1);
  const [completedTabs, setCompletedTabs] = useState(new Set());
  const [tabErrors, setTabErrors] = useState({});

  const tab1Ref = useRef();
  const tab2Ref = useRef();
  const tab3Ref = useRef();
  const tab4Ref = useRef();
  const tab5Ref = useRef();
  const tabRefs = {
    1: tab1Ref,
    2: tab2Ref,
    3: tab3Ref,
    4: tab4Ref,
    5: tab5Ref,
  };

  useEffect(() => {
    if (selectedEditPatient) {
      dispatch(handleSetPatientRegistrationPayload(selectedEditPatient));
    }
  }, [dispatch, selectedEditPatient]);

  // ── Collect current tab values into Redux before any navigation ────────────

  const collectAndSync = async (tabId) => {
    const ref = tabRefs[tabId];
    if (ref?.current?.collectValues) await ref.current.collectValues();
  };

  const handleStepClick = async (stepId) => {
    if (stepId === currPageView) return;
    await collectAndSync(currPageView);
    setCurrPageView(stepId);
  };

  const handleNext = async () => {
    await collectAndSync(currPageView);
    setCompletedTabs((prev) => new Set([...prev, currPageView]));
    setCurrPageView((prev) => Math.min(prev + 1, 5));
  };

  const handlePrevious = async () => {
    await collectAndSync(currPageView);
    setCurrPageView((prev) => Math.max(prev - 1, 1));
  };

  const handleCancelWithClear = () => {
    handleCancel();
    setTabErrors({});
    setCompletedTabs(new Set());
    // setCurrPageView(1);
  };

  const handleFinalSave = async (finalPayload) => {
    const errors = {};
    getValidationRules(finalPayload).forEach(({ tab, message, invalid }) => {
      if (invalid) {
        if (!errors[tab]) errors[tab] = [];
        errors[tab].push(message);
      }
    });
    if (Object.keys(errors).length > 0) {
      setTabErrors(errors);
      setCurrPageView(Math.min(...Object.keys(errors).map(Number)));
      return false;
    }
    setTabErrors({});
    return true;
  };

  // ── Step icon renderer ────────────────────────────────────────────────────

  const renderStep = (step) => {
    const isCompleted = completedTabs.has(step.id);
    const isActive = currPageView === step.id;
    const hasError = tabErrors[step.id]?.length > 0;
    // Tabs 2-5: locked (view-only) when RPM not enabled
    const isLocked = step.id > 1 && !isRpmEnabled;

    // Icon circle colour priority: error > active > completed > locked > default
    const circleClass = hasError
      ? "border-red-500   bg-red-50   text-red-500"
      : isActive
        ? "border-teal-500  bg-white    text-teal-500"
        : isCompleted
          ? "border-teal-500  bg-teal-500 text-white"
          : isLocked
            ? "border-gray-200  bg-gray-50  text-gray-300"
            : "border-gray-300   bg-white    text-gray-400";

    const labelClass = hasError
      ? "text-red-500"
      : isLocked
        ? "text-gray-300"
        : isActive || isCompleted
          ? "text-black"
          : "text-gray-400";

    return (
      <div key={step.id} className="flex flex-col items-center gap-1">
        {/* Clickable icon with optional badges */}
        <div
          className="relative cursor-pointer select-none group"
          onClick={() => handleStepClick(step.id)}
        >
          <div
            className={`w-9 h-9 flex items-center justify-center rounded-full border-2 transition-all duration-200 ${circleClass}`}
          >
            {hasError ? (
              <ExclamationCircleOutlined />
            ) : isCompleted && !isLocked ? (
              <CheckOutlined />
            ) : (
              <img
                src={step.icon}
                alt={step.title}
                className={isLocked ? "opacity-30" : ""}
              />
            )}
          </div>

          {/* 🔒 Small lock badge — top-right corner of icon */}
          {isLocked && (
            <span className="absolute -top-1 -right-1 w-4 h-4 rounded-full bg-gray-400 flex items-center justify-center shadow">
              <LockOutlined style={{ fontSize: 9, color: "#fff" }} />
            </span>
          )}

          {/* Error tooltip — hover */}
          {hasError && (
            <div
              className="absolute left-1/2 -translate-x-1/2 top-11 z-50 hidden group-hover:block
                                        bg-red-600 text-white text-xs rounded-md p-2 shadow-lg w-44 pointer-events-none"
            >
              {tabErrors[step.id].map((msg, i) => (
                <p key={i} className="leading-5">
                  • {msg}
                </p>
              ))}
            </div>
          )}

          {/* Lock tooltip — hover */}
          {isLocked && !hasError && (
            <div
              className="absolute left-1/2 -translate-x-1/2 top-11 z-50 hidden group-hover:block
                                        bg-gray-700 text-white text-xs rounded-md px-2 py-1 shadow-lg whitespace-nowrap pointer-events-none"
            >
              Enable RPM in Basic Details
            </div>
          )}
        </div>

        {/* Label */}
        <span
          className={`text-xs font-medium cursor-pointer select-none ${labelClass}`}
          onClick={() => handleStepClick(step.id)}
        >
          {step.title}
        </span>
      </div>
    );
  };

  return (
    <div className="pl-5">
      <div className="w-[80%] mx-auto my-4 px-4 pt-2">
        {/* Steps row */}
        <div className="flex justify-between items-start w-full mb-1">
          {STEPS.map(renderStep)}
        </div>

        {/* Progress bar */}
        <div className="relative w-full h-1 bg-gray-200 rounded-full mt-3">
          <div
            className="absolute h-1 bg-teal-500 rounded-full transition-all duration-500"
            style={{
              width: `${((currPageView - 1) / (STEPS.length - 1)) * 100}%`,
            }}
          />
        </div>
      </div>

      {/* Tab panels — all mounted, toggled via block/hidden to preserve form state */}
      <div>
        <div className={currPageView === 1 ? "block" : "hidden"}>
          <PatientBasicDetails
            ref={tab1Ref}
            handleCancel={handleCancelWithClear}
            handleSave={handleSave}
            handleNext={handleNext}
          />
        </div>
        <div className={currPageView === 2 ? "block" : "hidden"}>
          <RpmDetails
            ref={tab2Ref}
            currPageView={currPageView}
            handleCancel={handleCancelWithClear}
            handleNext={handleNext}
            handlePrevious={handlePrevious}
            isRpmEnabled={isRpmEnabled}
          />
        </div>
        <div className={currPageView === 3 ? "block" : "hidden"}>
          <ProgramInsurance
            ref={tab3Ref}
            currPageView={currPageView}
            handleCancel={handleCancelWithClear}
            handleNext={handleNext}
            handlePrevious={handlePrevious}
            isRpmEnabled={isRpmEnabled}
          />
        </div>
        <div className={currPageView === 4 ? "block" : "hidden"}>
          <VitalConfiguration
            ref={tab4Ref}
            currPageView={currPageView}
            handleCancel={handleCancelWithClear}
            handleNext={handleNext}
            handlePrevious={handlePrevious}
            isRpmEnabled={isRpmEnabled}
          />
        </div>
        <div className={currPageView === 5 ? "block" : "hidden"}>
          <Devices
            ref={tab5Ref}
            currPageView={currPageView}
            handleCancel={handleCancelWithClear}
            handleNext={handleNext}
            handlePrevious={handlePrevious}
            handleFinalSave={handleFinalSave}
            fetchUpdatedData={handleSave}
            isRpmEnabled={isRpmEnabled}
          />
        </div>
      </div>
    </div>
  );
}

export default Index;
